<template>
  <div class="chart-component" v-loading="chartLoading">
    <div class="container" :class="byDashboard ? 'by-dashboard' : ''">
      <div class="num-text single-ellipsis">{{ count.toLocaleString() }}</div>
    </div>
  </div>
</template>

<script>
import chartComponent from './mixins/chart-component';

export default {
  mixins: [chartComponent],
  data() {
    return {
      title: '-',
      count: 0
    };
  },
  computed: {
    chartType() {
      return 'numChart';
    }
  },
  methods: {
    initDataHandle(params) {
      this.formatData(params);
      return { type: this.chartType, isChart: false };
    },
    formatData(params) {
      const { originData, statistics } = params;
      const { rowsData } = originData;
      if (rowsData[0]) {
        this.title = statistics[0] && statistics[0].title;
        this.count = (rowsData[0] && rowsData[0].data[0]) || 0;
      } else {
        this.title = '-';
        this.count = 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'D-DINExp';
  src: url('../../assets/font/D-DINExp.otf');
}
.chart-component {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  color: #3d465a;
  padding: 0 10px;
  font-family: 'D-DINExp';

  .container {
    width: 100%;
    text-align: center;

    &.by-dashboard {
      text-align: left;
    }
    .num-text {
      width: 100%;
      font-size: 80px;
      font-weight: 500;
    }

    .title {
      font-size: 16px;
      margin-top: 10px;
    }
  }
}
</style>
